import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/context/AuthContext";
import { getPinnedWorkers } from "../index";
import { workersKeys } from "./keys";

/** Pinned workers for navigation shortcuts (summary payload). */
export function useWorkersPinned(options: { enabled?: boolean } = {}) {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();
  const enabled = (options.enabled ?? true) && isAuthenticated && !isAuthLoading;

  return useQuery({
    queryKey: workersKeys.pinned(),
    queryFn: () => getPinnedWorkers(),
    enabled,
  });
}
